/** Шаг 1 оформления: адрес и время доставки. */
import type {
  Address,
  CurrentUser,
  SlotsResponse,
} from '@arbuz/shared';
import { makeT } from '../../i18n';
import {
  IconCircle,
} from '../clientUi';
import { formatDay } from './helpers';

export function StepAddressTime({
  user,
  addresses,
  addressId,
  slots,
  slotDate,
  slotStart,
  onAddress,
  onNeedAddress,
  onSlot,
}: {
  user: CurrentUser;
  addresses: Address[];
  addressId: number | null;
  slots: SlotsResponse | null;
  slotDate: string | null;
  slotStart: string | null;
  onAddress: (id: number) => void;
  onNeedAddress: () => void;
  onSlot: (date: string, start: string) => void;
}) {
  const t = makeT(user.locale);
  const selectedAddress = addresses.find((a) => a.id === addressId) ?? addresses[0];
  const selectedDay = slots?.days.find((day) => day.date === slotDate) ?? slots?.days[0] ?? null;

  return (
    <>
      <h1 className="h1">{t('addressTitle')}</h1>
      <div className="client-map-preview" style={{ marginTop: 'var(--s-4)' }}>
        <span className="client-map-pin" />
      </div>

      <div style={{ display: 'grid', gap: 'var(--s-2)', marginTop: 'var(--s-3)' }}>
        {addresses.map((address) => (
          <button
            key={address.id}
            type="button"
            className={`client-payment-option${address.id === addressId ? ' active' : ''}`}
            onClick={() => onAddress(address.id)}
          >
            <IconCircle icon="location" />
            <span>
              <strong>{address.address_text}</strong>
              <span className="muted" style={{ display: 'block', fontSize: 'var(--fs-sm)' }}>
                {/* Название зоны здесь больше не показываем: зоны принадлежат
                    исполнителям, и имя чужой зоны ничего клиенту не говорит.
                    Осталась только сама покрытость — возит ли сюда кто-нибудь. */}
                {address.zone
                  ? [address.house, address.apartment].filter(Boolean).join(', ')
                  : t('outOfZone')}
              </span>
            </span>
            <span>{address.id === addressId ? '✓' : '›'}</span>
          </button>
        ))}
      </div>

      <button
        type="button"
        className="btn-primary"
        style={{ width: '100%', marginTop: 'var(--s-3)' }}
        onClick={onNeedAddress}
      >
        {selectedAddress ? t('changeAddress') : t('addAddress')}
      </button>

      <h2 style={{ margin: 'var(--s-8) 0 var(--s-3)', fontSize: 'var(--fs-h2)' }}>
        {t('slotTitle')}
      </h2>

      {!slots || !selectedDay ? (
        <p className="muted">…</p>
      ) : (
        <>
          <div className="client-chip-row">
            {slots.days.map((day) => (
              <button
                key={day.date}
                type="button"
                className={`client-chip${day.date === slotDate ? ' active' : ''}`}
                onClick={() => {
                  const first = day.slots.find((slot) => slot.available);
                  if (first) onSlot(day.date, first.start);
                }}
              >
                {formatDay(day.date, user.locale)}
              </button>
            ))}
          </div>
          <div className="client-chip-row">
            {selectedDay.slots.map((slot) => (
              <button
                key={slot.start}
                type="button"
                className={`client-chip${slot.start === slotStart ? ' active' : ''}`}
                disabled={!slot.available}
                title={slot.reason ? t(`slotReason_${slot.reason}` as never) : undefined}
                onClick={() => onSlot(selectedDay.date, slot.start)}
              >
                {slot.start}–{slot.end}
              </button>
            ))}
          </div>
        </>
      )}
    </>
  );
}

